import React, { useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { KeyRound, ArrowRight } from "lucide-react";
import { api } from "../../lib/api";
import { PageHeader, AdminBody, Card, Button } from "../../components/admin/Bits";

export default function ChangePassword() {
  const { register, handleSubmit, watch, formState: { errors } } = useForm();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);

  const onSubmit = async (data) => {
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: data.current_password, new_password: data.new_password });
      toast.success("Password changed");
      nav("/admin");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    } finally { setBusy(false); }
  };

  return (
    <>
      <PageHeader title="Change Password" subtitle="Set a new secure password." />
      <AdminBody>
        <Card className="p-8 max-w-xl">
          <KeyRound size={28} className="text-gold" />
          <form onSubmit={handleSubmit(onSubmit)} className="mt-4 space-y-4" data-testid="change-pw-form">
            <div>
              <label className="label">Current Password</label>
              <input type="password" className="input" {...register("current_password", { required: true })} data-testid="cp-current" />
              {errors.current_password && <div className="text-maroon text-xs mt-1">Required</div>}
            </div>
            <div>
              <label className="label">New Password</label>
              <input type="password" className="input" {...register("new_password", { required: true, minLength: 6 })} data-testid="cp-new" />
              {errors.new_password && <div className="text-maroon text-xs mt-1">At least 6 characters</div>}
            </div>
            <div>
              <label className="label">Confirm New Password</label>
              <input type="password" className="input" {...register("confirm", { required: true, validate: v => v === watch("new_password") || "Mismatch" })} data-testid="cp-confirm" />
              {errors.confirm && <div className="text-maroon text-xs mt-1">{errors.confirm.message || "Required"}</div>}
            </div>
            <Button disabled={busy} type="submit" data-testid="cp-submit">{busy ? "Changing…" : <>Change Password <ArrowRight size={14} /></>}</Button>
          </form>
        </Card>
      </AdminBody>
    </>
  );
}
